import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { FormElement } from 'src/front/components/FormStyles';
import { TextInput } from '@code/innovance-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';

interface Props {
  formatter: (v: string) => string;
  formMethods: UseFormMethods<IdentityFormData>;
  max: number;
  min: number;
  onChangeHandler: (field: string) => (value: string) => void;
}
const DocumentCode: FC<Props> = ({ formatter, formMethods, max, min, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();

  return (
    <FormElement>
      <Controller
        control={control}
        name="identityDocumentSerialCode"
        render={({ onChange, value }) => (
          <TextInput
            errorMessage={t(errors?.identityDocumentSerialCode?.message as string, { min })}
            formatter={formatter}
            label={t('general_documentSeries_label')}
            maxLength={max}
            name="identityDocumentSerialCode"
            onChange={(val) => {
              onChange(val);
              onChangeHandler('identityDocumentSerialCode')(val);
            }}
            value={value}
            required
          />
        )}
      />
    </FormElement>
  );
};

export default DocumentCode;
